import Vue from 'vue'
import WarehouseTransformer
from '../../../transformers/catalog/warehouse/warehouse'

/**
 * @author jorge nuñez lópez <>
 *
 * Get separated supplies with extra info for warehouse
 * @return {object}
 */

function urlParamsTransformer(options) {
  return {
    page: options.page,
    size: options.pageSize,
    camp: options.campId,
    ascending_order: options.asc ? true : undefined,
    affected: options.affected || undefined
  }
}

export default (warehouseId, fetchOptions) => {
  const params = fetchOptions ? urlParamsTransformer(fetchOptions) : null

  return Vue.$http.get(`purchase/warehouse/${warehouseId}/separated/`, { params })
    .then(response => {
      const { results, ...paginationInfo} = response.data
      const separated = WarehouseTransformer.fetchSeparated(results)
      return { separated, paginationInfo }
    })
    .catch((error) => {
      const response = error.response

      if (response && response.status !== 404) {
        throw error
      }
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchSeparated.js